/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_Delete_ConfirmInputs */

const vi_tea_package_delete_confirm = /** @type {(inputs: Tea_Package_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa gói chè này?`)
};

/**

* @param {Tea_Package_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_delete_confirm = /** @type {((inputs?: Tea_Package_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_delete_confirm(inputs)
});